import { Box } from '@mui/material';
import { Controls, NodeTypes, ReactFlow, ReactFlowProvider } from '@xyflow/react';
import { WorkflowCanvasProps } from './workflow-canvas.types';
import { AutoFitView } from './components/auto-fit-view/auto-fit-view';
import { ActionNode } from './components/action-node/action-node';
import '@xyflow/react/dist/style.css';
import { EnrollNode } from './components/enroll-node/enroll-node';
import { WaitNode } from './components/wait-node/wait-node';

const nodeTypes: NodeTypes = {
  enroll: EnrollNode,
  wait: WaitNode,
  action: ActionNode,
};

const defaultEdgeOptions = { type: 'smoothstep' as const };

export const WorkflowCanvas = ({ graphControl, onNodeDoubleClick }: WorkflowCanvasProps) => {
  return (
    <Box flex={1}>
      <ReactFlowProvider>
        <ReactFlow
          nodes={graphControl.nodes}
          edges={graphControl.edges}
          nodeTypes={nodeTypes}
          defaultEdgeOptions={defaultEdgeOptions}
          nodeOrigin={[0.5, 0.5]}
          onNodesChange={graphControl.onNodesChange}
          onEdgesChange={graphControl.onEdgesChange}
          onNodeDoubleClick={(_, node) => {
            onNodeDoubleClick(node);
          }}
          nodesDraggable={false}
          nodesConnectable={false}
          fitView
        >
          <Controls />
          <AutoFitView nodeCount={graphControl.nodes.length} />
        </ReactFlow>
      </ReactFlowProvider>
    </Box>
  );
};
